import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { NavigationSource } from "../../common/enums/NavigationSource";
import { UIViewEnum } from "../../common/enums/UIViewEnum";
import { RouteContextStateType, RouteContextType } from "./UseRouteContext";

export function getRouteContext(viewID: UIViewEnum, queryString: string, state?: RouteContextStateType): RouteContextType {

    const queryParams = new URLSearchParams(queryString);

    const organizationID = queryParams.has("organizationID") ? Number(queryParams.get("organizationID")) : undefined;
    const groupID = queryParams.has("groupID") ? Number(queryParams.get("groupID")) : undefined;
    const tankBatteryID = queryParams.has("tankBatteryID") ? Number(queryParams.get("tankBatteryID")) : undefined;
    const deviceID = queryParams.has("deviceID") ? Number(queryParams.get("deviceID")) : undefined;
    const wellID = queryParams.has("wellID") ? Number(queryParams.get("wellID")) : undefined;
    const tankID = queryParams.has("tankID") ? Number(queryParams.get("tankID")) : undefined;
    const tagID = queryParams.has("tagID") ? Number(queryParams.get("tagID")) : undefined;

    //const activeTab = queryParams.has("activeTab") ? Number(queryParams.get("activeTab")) : undefined;

    // const configurationID = queryParams.has("configurationID") ? Number(queryParams.get("configurationID")) : undefined;
    const siteID = queryParams.has("siteID") ? Number(queryParams.get("siteID")) : undefined;
    const typeID = queryParams.has("typeID") ? Number(queryParams.get("typeID")) : undefined;

    const restoreState = queryParams.has("restoreState") ? true : undefined;
    const newUser = queryParams.has("restoreState") ? true : undefined;

    const navSrc = queryParams.has("navSrc") ? Number(queryParams.get("navSrc")) as NavigationSource : undefined;

    const token = queryParams.has("token") ? queryParams.get("token") : undefined;

    const contextObject =
        tagID
            ? {
                objectType: eLynxObjectTypeEnum.Tag,
                id: +tagID
            }
            : tankID
                ? {
                    objectType: eLynxObjectTypeEnum.Tank,
                    id: +tankID
                }
                : tankBatteryID
                    ? {
                        objectType: eLynxObjectTypeEnum.TankBattery,
                        id: +tankBatteryID
                    }
                    : deviceID
                        ? {
                            objectType: eLynxObjectTypeEnum.Device,
                            id: +deviceID
                        }
                        : wellID
                            ? {
                                objectType: eLynxObjectTypeEnum.Well,
                                id: +wellID
                            }
                            : groupID
                                ? {
                                    objectType: eLynxObjectTypeEnum.Group,
                                    id: +groupID
                                }
                                : undefined;

    return {
        organizationID: organizationID,
        groupID: groupID,
        tankBatteryID: tankBatteryID,
        deviceID: deviceID,
        wellID: wellID,
        tankID: tankID,
        tagID: tagID,
        //activeTab: activeTab,
        //configurationID: configurationID,
        siteID: siteID,
        typeID: typeID,
        restoreState: restoreState,
        newUser: newUser,
        navSrc: navSrc,
        token: token,
        contextObject: contextObject,
        viewID: viewID,
        state: state
    };
}